module.exports = __webpack_public_path__ + "img/5.a157d876.png";